import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-navy text-white pt-24 pb-10 mt-24"
        >
            <div className="container-x">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="md:col-span-4">
                        <div className="mb-8 flex items-center gap-4">
                            <img
                                src="/brand/scalexa-mark-v2.png"
                                alt="Scalexa Group — Revenue. Engineered."
                                className="h-12 w-12 object-contain"
                                data-testid="footer-logo"
                            />
                            <span className="font-heading text-2xl font-medium tracking-tight">
                                SCALEXA
                                <span className="block text-[10px] font-mono tracking-[0.3em] text-white/50 font-normal">
                                    Group · Fundado 2026
                                </span>
                            </span>
                        </div>
                        <p className="text-white/70 max-w-md leading-relaxed">
                            Consultoría, dirección externa y ejecución comercial.
                            Combinamos experiencia humana con inteligencia
                            artificial para construir organizaciones que crecen
                            con predictibilidad.
                        </p>
                        <Link
                            to="/contact"
                            data-testid="footer-cta-contact"
                            className="mt-8 inline-flex items-center gap-2 text-white border-b border-white/40 pb-1 hover:border-white transition-colors"
                        >
                            Inicia una colaboración <ArrowUpRight size={16} />
                        </Link>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-mono !text-white/60 mb-5">Servicios</div>
                        <ul className="space-y-3 text-white/80">
                            {SERVICES.map((s) => (
                                <li key={s.slug}>
                                    <Link
                                        to={`/services/${s.slug}`}
                                        className="hover:text-white transition-colors"
                                        data-testid={`footer-service-${s.slug}`}
                                    >
                                        {s.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="label-mono !text-white/60 mb-5">Navegación</div>
                        <ul className="space-y-3 text-white/80">
                            {[
                                ["/", "Inicio", "footer-link-inicio"],
                                ["/#casos", "Casos y experiencia", "footer-link-casos"],
                                ["/saas", "SaaS — Próximamente", "footer-link-saas"],
                                ["/about", "Nosotros", "footer-link-nosotros"],
                                ["/contact", "Contacto", "footer-link-contacto"],
                                ["/assessment", "Diagnóstico", "footer-link-diagnóstico"],
                            ].map(([to, label, testid]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        className="hover:text-white transition-colors"
                                        data-testid={testid}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-mono !text-white/60 mb-5">Contacto</div>
                        <ul className="space-y-3 text-white/80">
                            <li>partners@scalexa-group.com</li>
                            <li>www.scalexa-group.com</li>
                            <li>Madrid · Calle López de Hoyos 42 (Entrada por Edison, 3), 28006</li>
                            <li>Ciudad de México · Presencia operativa</li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pt-8 text-sm">
                    <span className="text-white/50 font-mono tracking-wider text-xs">
                        © {new Date().getFullYear()} Scalexa Group, Todos los derechos reservados.
                    </span>
                    <span className="text-white/50 font-mono tracking-wider text-xs">
                        CONSULTORÍA · DIRECCIÓN · INTELIGENCIA ARTIFICIAL
                    </span>
                </div>
            </div>
        </footer>
    );
}
